export default __webpack_public_path__ + "static/media/sounds/spelling_click_ok_practice_instruction_alyx.mp3";